import { Box, Paper, Typography } from "@mui/material";
import { useMediaQuery } from "@uidotdev/usehooks";
import React from "react";

interface Props {
  header?: React.ReactNode;
  titleAction?: React.ReactNode;
  children: React.ReactNode;
}

export function JobEventsLayout({ header, titleAction, children }: Props) {
  const isXs = useMediaQuery("(max-width: 600px)");

  return (
    <Box
      sx={{
        width: "100%",
        p: 3,
        minHeight: "250px",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
          flexDirection: isXs ? "column" : "row",
          gap: isXs ? 1 : 0,
          width: "100%",
        }}
      >
        {/* Title */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 500,
              color: "text.primary",
              fontSize: isXs ? "1rem" : null,
            }}
          >
            Visits
          </Typography>
          {titleAction}
        </Box>

        {/* TODO: wire up sort + search before re-enabling
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          { }
        </Typography>

        <Box
          sx={{
            display: "flex",
            gap: 2,
            alignItems: isXs ? "stretch" : "center",
            flexDirection: isXs ? "column" : "row",
            width: isXs ? "100%" : "auto",
            maxWidth: isXs ? "100%" : 560,
          }}
        >
          <Select
            size="small"
            value="upcoming"
            fullWidth={isXs}
            sx={{
              width: isXs ? "100%" : "auto",
              minWidth: isXs ? "100%" : 220,
              backgroundColor: "transparent",
              transition: "all 0.2s ease-in-out",
              border: "1px solid rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.12)",
              borderRadius: "20px",
              "& .MuiOutlinedInput-notchedOutline": { borderColor: "transparent" },
              "&:hover": {
                backgroundColor: "rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.02)",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.12)",
                },
              },
              "&.Mui-focused": {
                backgroundColor: "var(--fx-surface-base, #FFFFFF)",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.4)",
                  borderWidth: "1px",
                },
              },
              "& .MuiSelect-select": { color: "rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.4)" },
              "& .MuiSvgIcon-root": {
                color: "rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.4)",
                transition: "color 0.2s ease-in-out",
              },
            }}
            MenuProps={{
              disablePortal: false,
              sx: { zIndex: 99999999 },
              PaperProps: { sx: { zIndex: 99999999 } },
            }}
          >
            <MenuItem value="upcoming">Sort: Upcoming First</MenuItem>
            <MenuItem value="past">Sort: Past First</MenuItem>
          </Select>

          <TextField
            size="small"
            placeholder="Search workforce..."
            fullWidth={isXs}
            sx={{
              width: isXs ? "100%" : 260,
              "& .MuiOutlinedInput-root": {
                borderRadius: "20px",
                backgroundColor: "transparent",
                transition: "all 0.2s ease-in-out",
                "& fieldset": {
                  borderColor: "rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.12)",
                  borderRadius: "20px",
                },
                "&:hover": {
                  backgroundColor: "rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.02)",
                  "& fieldset": { borderColor: "rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.2)" },
                },
                "&.Mui-focused": {
                  backgroundColor: "var(--fx-surface-base, #FFFFFF)",
                  "& fieldset": {
                    borderColor: "rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.4)",
                    borderWidth: "1px",
                  },
                },
              },
              "& .MuiInputBase-input::placeholder": {
                color: "rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.4)",
                opacity: 1,
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon
                    fontSize="small"
                    sx={{
                      color: "rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.4)",
                      transition: "color 0.2s ease-in-out",
                    }}
                  />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        */}
      </Box>

      <Paper
        elevation={0}
        sx={{
          borderRadius: 2,
          p: 2,
          minHeight: 300,
          display: "flex",
          flexDirection: "column",
          backgroundColor: "background.paper",
        }}
      >
        {children}
      </Paper>
    </Box>
  );
}
